"use strict";
var ApiMessage = (function () {
    function ApiMessage(messageText, messageCode, messageType, messageSeverity) {
        this.text = messageText;
        this.code = messageCode;
        this.type = messageType;
        this.severity = messageSeverity;
        this.acknowledgements = [];
    }
    return ApiMessage;
}());
exports.ApiMessage = ApiMessage;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-message.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-message.model.js